/**
 * @example
 * const [startOffset, endOffset] = getSelectionOffsets();
 */
export function selectionGetOffsets(): [number | null, number | null] {
  const selection = window.getSelection();

  if (selection) {
    const { startOffset, endOffset } = selection.getRangeAt(0);

    return [startOffset, endOffset];
  }

  return [null, null];
}
